import Icon from "@ant-design/icons"
import React from "react"

const NewVendorDetectedSvg = ({ isHighlighted }: { isHighlighted: boolean }) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="4" fill="#F5F5F5" />
        <path
            d="M9.75 18.5833H27.25L25.5833 15.25H11.4167C11.4167 15.25 9.78472 18.5833 9.75 18.5833Z"
            stroke="#606C7E"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.416 15.25V14C11.416 13.3096 11.9757 12.75 12.666 12.75H24.3327C25.023 12.75 25.5827 13.3096 25.5827 14V15.25"
            stroke="#606C7E"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.75 18.584C9.75 19.9647 10.8693 21.084 12.25 21.084C12.9746 21.084 13.6218 20.7709 14.0784 20.2783C14.4302 21.2329 15.3399 21.9173 16.4167 21.9173C17.2873 21.9173 18.0523 21.4712 18.5 20.7962C18.9477 21.4712 19.7127 21.9173 20.5833 21.9173C21.6601 21.9173 22.5698 21.2329 22.9216 20.2783C23.3782 20.7709 24.0254 21.084 24.75 21.084C26.1307 21.084 27.25 19.9647 27.25 18.584"
            stroke="#606C7E"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M14.0781 20.2777V18.5833L14.7498 15.25" stroke="#606C7E" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M22.9216 20.2777V18.5833L22.25 15.25" stroke="#606C7E" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M18.5 20.7955V15.25" stroke="#606C7E" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M11.416 21.084V29.0007C11.416 29.691 11.9757 30.2507 12.666 30.2507H24.3327C25.023 30.2507 25.5827 29.691 25.5827 29.0007V21.084"
            stroke="#606C7E"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M23.0827 23.584H18.916V30.2507H23.0827V23.584Z" stroke="#606C7E" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M17.2493 23.584H13.916V26.9173H17.2493V23.584Z" stroke="#606C7E" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        {isHighlighted && (
            <g filter="url(#filter0_d_868_45958)">
                <circle cx="26.5" cy="13.5" r="5" fill="#FBAC3B" />
                <circle cx="26.5" cy="13.5" r="4.5" stroke="#F5F5F5" />
            </g>
        )}
        <defs>
            <filter id="filter0_d_868_45958" x="16.5" y="3.5" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_868_45958" />
                <feOffset />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.984314 0 0 0 0 0.67451 0 0 0 0 0.231373 0 0 0 0.5 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_868_45958" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_868_45958" result="shape" />
            </filter>
        </defs>
    </svg>
)

const NewVendorDetectedIcon = (props: any) => <Icon component={() => <NewVendorDetectedSvg isHighlighted={props.isHighlighted} />} {...props} />

export default NewVendorDetectedIcon
